import React, { Component } from 'react'
import Form from '../common/form/Form'
import FormField from '../common/form/FormField';
import '../../../styles/regEcp.css'
import closeIcon from '../../../img/icons/X.svg'
import { withRouter } from 'react-router-dom';
import desk_inst from '../../../document/desktop_ins.pdf'

class RegEcp extends Component {
    constructor(props) {
        super(props)
        console.log(props);
    }

    componentDidMount() {
        this.props.getUserCertificatesAction();
    }

    componentWillUnmount() {
        if (this.props.authByDs && localStorage.getItem('authByDs')) {
            this.props.authByDsAct(false)
            localStorage.removeItem('authByDs')
            //this.props.history.push('/login')
        }
    }
    renderFields = (fields, name) => {
        var result = [];

        for (var attribute in fields) {
            if (fields.hasOwnProperty(attribute)) {

                result.push(<div className="form__row" key={name + attribute}>
                    <FormField
                        fieldConfig={{ ...fields[attribute], label: fields[attribute].label }}
                        attribute={attribute}
                        onChange={this.props.onSelecSignature}
                    />
                </div>)
            }
        }

        return result;
    };
    hanldeClose = () => {
        if (this.props.authByDs) this.props.authByDsAct(false)
        if (this.props.regByDs) this.props.regByDsAct(false)
        if (this.props.recByDs) this.props.handleCloseRecDs()
        this.props.history.push('/login', { switcher: this.props.isRegPage })
    }

    closeAndGoToRegister = (e) => {
        e.preventDefault()
        if (this.props.authByDs) this.props.authByDsAct(false)
        this.props.regByDsAct(false)
        if (this.props.isRegPage) return this.props.history.push('/registration')
        this.props.history.push('/login')
    }

    closeAndGoToRecovery = (e) => {
        e.preventDefault()
        if (this.props.authByDs) this.props.authByDsAct(false)
        this.props.regByDsAct(false)
        this.props.history.push('/recovery')
    }

    render() {
        return (
            <div>
                {this.props.diadocState.noActiveCerf ?
                    <div className='auth__form__ecp__box'>
                        <div className='icon__block' onClick={this.hanldeClose}>
                            <img src={closeIcon} />
                        </div>
                        <div>
                            <div className='auth__form__ecp_error'>
                                <h3>Ошибка электронной подписи</h3>
                                <Form validate={true}>
                                    <p>
                                        Отсутствует активная электронная подпись юридического лица. Попробуйте использовать другой источник с электронной подписью юридического лица или индивидуального предпринимателя либо зарегистрируйтесь по номеру телефона
                                    </p>
                                    <div className='form__buttons_error'>
                                        <button className='reg_by_ds_repeat_btn' onClick={() => this.props.getUserCertificatesAction()}>Повторить</button>
                                        <button className='setup_workspace_btn'>
                                            <a href={desk_inst} target='_blank' >
                                                Инструкция по настройке рабочего места
                                            </a>
                                        </button>
                                    </div>
                                </Form>
                            </div>
                            <div className='reg_by_phone_block'>
                                <button className='setup_workspace_btn' onClick={this.closeAndGoToRegister}>Регистрация по номеру телефона</button>
                            </div>
                        </div>
                    </div>
                    :
                    this.props.diadocState.dsError ?
                        <div className='auth__form__ecp__box'>
                            <div className='icon__block' onClick={this.hanldeClose}>
                                <img src={closeIcon} />
                            </div>
                            <div className='auth__form__ecp'>
                                <h3>Что-то пошло не так...</h3>
                                <Form validate={true}>
                                    <p>
                                        {this.props.diadocState.checkSignatureRes.message}
                                        {/* Сервис временно недоступен. Пожалуйста, повторите попытку регистрации позднее или зарегистрируйтесь по номеру телефона */}
                                    </p>
                                    <div className='form__buttons_error'>
                                        <button type='button' className={'reg_by_ds_register_btn' + (this.props.isRegPage ? ' phone' : '')} onClick={this.closeAndGoToRegister}>{this.props.isRegPage ? "Регистрация по номеру телефона" : "Вход по номеру телефона"}</button>
                                        <button onClick={() => this.props.getUserCertificatesAction()} className='repeat_another_btn ds'>Повторить с другой ЭП</button>
                                    </div>
                                </Form>
                            </div>

                        </div>
                        :
                        this.props.diadocState.error ?
                            <div className='auth__form__ecp__box'>
                                <div className='icon__block' onClick={this.hanldeClose}>
                                    <img src={closeIcon} />
                                </div>
                                <div>
                                    <div className='auth__form__ecp_error'>
                                        <h3>Ошибка Крипто.Про</h3>
                                        <Form validate={true}>
                                            <p>
                                                Отсутствует расширение для работы плагина КриптоПро ЭЦП Browser plug-in. Проверьте настройку рабочего места с помощью инструкции или {this.props.isRegPage ? "зарегистрируйтесь" : "войдите"} по номеру телефона
                                            </p>
                                            <div className='form__buttons_error'>
                                                <button className='reg_by_ds_repeat_btn' onClick={() => this.props.getUserCertificatesAction()}>Повторить</button>
                                                <button className='setup_workspace_btn'>
                                                    <a href={desk_inst} target='_blank' >
                                                        Инструкция по настройке рабочего места
                                                    </a>
                                                </button>
                                            </div>
                                        </Form>
                                    </div>
                                    <div className='reg_by_phone_block'>
                                        <button className='setup_workspace_btn by_number' onClick={this.props.isRegPage ? this.closeAndGoToRegister : this.hanldeClose}>{this.props.isRegPage ? "Регистрация по номеру телефона" : "Вход по номеру телефона"}</button>
                                    </div>
                                </div>

                            </div>
                            :
                            <div className='auth__form__ecp__box'>
                                <div className='icon__block' onClick={this.hanldeClose}>
                                    <img src={closeIcon} />
                                </div>
                                <div className='auth__form__ecp'>
                                    <h3>Подключите носитель электронной подписи</h3>
                                    <Form validate={true} onSubmit={this.props.onSubmit}>
                                        <div className='ds_inputs choose_dropdown'>
                                            {this.renderFields(this.props.fieldsEc, 'fieldsEc')}
                                        </div>
                                        <div className='form__buttons_ecp choose_dropdown'>
                                            <button className='btn btn_clear_blue_auth' onClick={this.hanldeClose}>Назад</button>
                                            <button type='submit' className={`btn btn_orange ${!this.props.fieldsEc.digitalSignature.value ? ' disabled_auth' : this.props.disabled ? ' disabled_auth' : ''}`}>Далее</button>
                                        </div>
                                    </Form>
                                </div>

                            </div>
                }
            </div>
        )
    }
}

export default withRouter(RegEcp)